module.exports = __webpack_public_path__ + "static/media/spinner.8c568787.svg";